'use client'

import { Guarantee } from '@src/app/[country]/[lang]/checkout/modules/Guarantee'
import { Accordion } from '@src/components/Accordion/Accordion'
import { Disclaimer } from '@src/components/DisclaimerList/Disclaimer'
import { useLocale } from '@src/i18n/LocaleProvider'
import { getAttribute, parseDisclaimers, parseGuarantees } from '@src/utils/product.util'

export const ProductDescriptionSection = ({ viewModel }: { viewModel: ViewModel }) => {
  const { t, locale } = useLocale('common')
  const { selectedVariant, product } = viewModel

  const accordionContent = []
  const description = product.description?.[locale.code]
  const ingredients = getAttribute(selectedVariant, 'productFeaturedIngredients', locale.code)
  const productDirections = getAttribute(selectedVariant, 'productDirections', locale.code)

  description && accordionContent.push({ title: t('description'), content: description })
  productDirections && accordionContent.push({ title: t('how-to-use'), content: productDirections })
  ingredients && accordionContent.push({ title: t('key-ingredients'), content: ingredients })

  const disclaimers = parseDisclaimers(getAttribute(selectedVariant, 'disclaimers'), locale.code)

  const guarantees = parseGuarantees(getAttribute(selectedVariant, 'guarantees'), locale.code)

  return (
    <div className="w-full pt-3">
      {disclaimers.map((disclaimer) => (
        <Disclaimer key={disclaimer.id} content={disclaimer?.content} />
      ))}
      {guarantees.map((guarantee) => (
        <Guarantee key={guarantee.id} content={guarantee?.content} icon={guarantee.icon} />
      ))}
      <Accordion items={accordionContent} />
    </div>
  )
}
